import React from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Footer from '@boschebike/ebds-react/dist-esm/components/Footer.js';

const socialLinkIcon = (iconName) => <IconAsChunk iconName={iconName || 'link'} />;

const getVersionHash = (version, appVersion) => {
  if (!version) {
    return undefined;
  }

  return `${version}${appVersion || ''}`;
};

/**
 * @typedef {import('../App.d.ts').DodoFooterProps} DodoFooterProps
 */
/**
 * @param {DodoFooterProps} props
 */
const DodoFooter = ({
  meta,
  footer,
  userData,
  withLightFooter = false,
}) => {
  const withConsentPrompt = !!meta?.consent;
  const consentLang = userData.lang.current;

  const socialLink = (v) => ({
    label: v.label,
    url: v.url,
    Icon: () => socialLinkIcon(v.icon),
  });

  const buttonLink = (v) => ({
    label: v.label,
    url: v.url,
    Icon: () => socialLinkIcon(v.icon),
    onClick: v.onClick,
    isExternal: v.isExternal,
  });

  return (
    <Footer
      socialLinks={footer?.social?.links?.map(socialLink)}
      footerLinks={footer?.main?.links ?? []}
      legalLinks={footer?.legal?.links ?? []}
      buttons={footer?.buttons?.links?.map(buttonLink) ?? undefined}
      claim={meta.claim}
      withConsentPrompt={withConsentPrompt}
      copyrightNotice={meta.copyrightNotice ? meta.copyrightNotice : undefined}
      consentLang={consentLang}
      consentProps={{
        links: meta?.consent?.links ?? {},
        cookieName: meta?.consent?.cookieName ?? 'dodo-consent',
      }}
      scrollToTop={{ useJavascriptScrollToTop: true }}
      versionText={getVersionHash(meta?.version, meta?.appVersion)}
      variant={withLightFooter ? Footer.variants.LIGHT : Footer.variants.DARK}
      constrained
    />
  );
};

export default DodoFooter;
